import Badge from './Badge.component';

export default Badge;
